import enModal from "./en";
import frModal from "./fr";
import deModal from "./de";

export { enModal, frModal, deModal };
